<template>
  <div>
    <SkeletonCard v-if="loading"></SkeletonCard>
    <div v-else>
      <LatestAnalysis class="sticky top-[60px]" :data="data" :isGereputationDetail="true"></LatestAnalysis>
      <div class="headSectionIA sticky top-[124px] bg-[#F2F2F2]">
        <span class="name">
          <translate>GeoReputation</translate>
        </span>
        <div class="groupText">
          <span class="first"><translate>Indicates the visibility, position, and sentiment of each restaurant in each LLM. Topics (attributes) and alignment (% correct topics)</translate></span>
          <div class="second"><translate :translate-params="{
      numberOfPrompts
      }">Analysis based on %{numberOfPrompts} GeoPrompts.</translate></div>
        </div>

      </div>
      <div id="tableLocals">


      <div class="rowGeo head sticky top-[195px] bg-white">
        <div>
          <div id="searchLocal">
            <img src="@/assets/img/search.svg" />
            <input type="text" :placeholder="$gettext('Search restaurant')" v-model="search">
          </div>
        </div>
        <div class="d-flex gap-2">
          <translate>Visibility</translate>
          <Sort orderBy="visibility" :orderByActual="ordering" @sort="setOrdering"></Sort>
        </div>
        <div  class="d-flex gap-2">
          <translate>Position</translate>
          <Sort orderBy="position" :orderByActual="ordering" @sort="setOrdering"></Sort>
        </div>
        <div class="grid gap-2 items-center justify-center" :style="`grid-template-columns: repeat(${llms.length}, 1fr)`">
          <div class="d-flex justify-center" v-for="(llm, index) in llms" :key="index">
            <img :src="getLogoByLLM(llm, true)" />
          </div>
        </div>
        <div  class="d-flex gap-2">
          <translate>Feeling</translate>
          <Sort orderBy="feeling" :orderByActual="ordering" @sort="setOrdering"></Sort>
        </div>

        <div class="d-flex gap-2">
          <translate>Topics</translate>
          <span class="label"><translate>Present</translate>

          </span>
          <Sort orderBy="topics" :orderByActual="ordering" @sort="setOrdering"></Sort>
        </div>
        <div  class="d-flex gap-2">
          <translate>Alignment</translate>
          <Sort orderBy="alignment" :orderByActual="ordering" @sort="setOrdering"></Sort>
        </div>
      </div>

      <div v-for="(item, index) in sitesOrdered" :key="index" >
        <SkeletonCard v-if="item.loading"></SkeletonCard>
        <div v-if="!item.loading" class="rowGeo body cursor-pointer" :class="{'open': item.show}"
             @click="$router.push({name: 'GeoReputationDetail', params: $route.params, query: {...$route.query, site_uuid: item.site.uuid}})">
          <div class="colRestaurant">
            <div class="tw-flex gap-2 items-center text-purple">
              <img src="@/assets/img/IAReputation/godetailgeo.svg" />
              <p>
                {{ item.site.name }} </p>
            </div>

          </div>
          <div class="colVisibility">
            <img v-if="getVisibility(item)" src="@/assets/img/IAReputation/check.svg" />
            <img v-else src="@/assets/img/IAReputation/xcircle.svg">
          </div>
          <div class="text-center">
            {{ item.aggregated_ranking.some(e => e.is_current || (lowerAndTrim(e.name) === lowerAndTrim(brandName)) ) ? item.aggregated_ranking.filter(e => e.is_current || (lowerAndTrim(e.name) === lowerAndTrim(brandName)))[0].position+'º' : '-' }}
          </div>
          <div class="colCompetitors">
            <div class="grid gap-2 items-center justify-center" :style="`grid-template-columns: repeat(${llms.length}, 1fr)`">
              <div v-for="(llm, index) in llms" :key="index" class="text-center">
                {{ getPositionByLLM(llm, item) }}
              </div>
            </div>
          </div>
          <div class="colSentiment">
            <div class="tw-flex justify-center">
              <div class="tw-flex items-center gap-2">
                <img :src="getImageByScoreLLM(getSentimentGlobal(item))" class="h-[14px]" alt=""  />
                <span :style="{color: getColorByScore(getSentimentGlobal(item))}">
                  {{ getSentimentGlobal(item) | formatNumber(2,2) }}
                </span>
              </div>
            </div>

          </div>

          <div class="colTopics">
            <div class="tw-flex justify-center">

              <span class="number text-present">{{ item.aggregated_attributes.summary.counts.present }}</span>
            </div>

          </div>
          <div class="text-center colAlignment">
            <span :style="{color: getColorByPercent(item.aggregated_attributes.summary.overall_scores.alignment_score)}">
              {{ item.aggregated_attributes.summary.overall_scores.alignment_score | formatNumber(2,2) }} %</span>
          </div>

        </div>
      </div>
      </div>

    </div>

  </div>
</template>

<script>
import LatestAnalysis from "@/components/IAReputation/LatestAnalysis.vue"
import MixinIAReputation from "@/mixins/iareputation.js"
import SrvIAReputationService from "@/services/iareputation.js"
import SkeletonCard from '@/components/common/skeletonCard.vue'
import Sort from '@/components/common/Sort.vue'

export default {
  components: {LatestAnalysis, SkeletonCard, Sort},
  mixins: [MixinIAReputation],
  data() {
    return {
      data: null,
      loading: false,
      itemActive: null,
      tabActive: 'openai',
      showModalGeoPrompts: false,
      showModalGeoTopics: false,
      showEditPrompts: false,
      search: null,
      ordering: '-position'
    }
  },
  async mounted() {
    this.loading = true
    try {
      const {status, data} = await SrvIAReputationService.getReputation({brand_uuid: this.brandUUID})
      if (status === 200) {
        data.sites = data.sites.map(e => {
          return {
            site_uuid: e,
            show: false,
            loading: true
          }
        })
        this.data = data
        //
        this.data.sites.forEach(async (id, index) => {
          try {
            const response = await SrvIAReputationService.getReputation({brand_uuid: this.brandUUID, site_uuid: id.site_uuid});
            this.data.sites = this.data.sites.map((site, i) => {
              console.log(i, index)
              if (i === index) {
                return { ...site, ...response.data, loading: false };
              }
              return site;
            });
            //this.data.sites[index] = {...this.data.sites[index], ...response.data, loading: false}
          } catch (error) {
            console.log(error)
          }
        });

      }
    } catch (e) {
      console.log(e)
    }
    this.loading = false
  },
  methods: {
    setOrdering (key) {
      this.ordering = key
    },
    getVisibility (item) {
      let visibility = false
      Object.keys(item.reputation_index).forEach(e => {
        if (item.reputation_index[e].metrics_results.visibility.visibility) {
          visibility = true
        }
      })
      return visibility
    },
    lowerAndTrim (val) {
      return val.toLowerCase().replaceAll(" ",'')
    },
    getPositionByLLM (llm, item)  {
      let pos = item.reputation_index[llm].metrics_results.ranking.all_competitors_ranks.findIndex(e => (this.lowerAndTrim(e.name) === this.lowerAndTrim(item.site.name)) || (this.lowerAndTrim(e.name) === this.lowerAndTrim(this.brandName)))
      if (pos > -1) {
        return pos + 1 + 'º'
      }
      return '-'
    },
    getSentimentGlobal (item) {
      //item.reputation_index[this.tabActive].metrics_results.sentiment.avg_score
      let sum = 0
      let count = 0
      this.llms.forEach(e => {
        if (item.reputation_index[e]?.metrics_results?.sentiment?.avg_score) {
          sum += item.reputation_index[e].metrics_results.sentiment.avg_score
          count++
        }
      })
      return sum / count
    }
  },
  computed: {
    sites () {
      if (!this.data) return []
      if (this.search) return this.data.sites.filter(e => e.site.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1)
      return this.data.sites.filter(e => e.created_at)
    },
    sitesOrdered () {
      if (!this.data) return []
      const list = [...this.sites] // 🔥 Clonar evita el bucle
      // SI ORDENAN POR VISIBILIDAD
      if (this.ordering.indexOf('visibility') > -1) {
        if (this.ordering.indexOf('-') > -1) {
          return list.sort((a, b) => this.getVisibility(b) - this.getVisibility(a))
        } else {
          return list.sort((a, b) => this.getVisibility(a) - this.getVisibility(b))
        }
      }
      // SI ORDENAN POR POSICION
      if (this.ordering.indexOf('position') > -1) {
        const getPos = (item) => {
          return item.aggregated_ranking?.some(e => e.is_current || (this.lowerAndTrim(e.name) === this.lowerAndTrim(this.brandName))) ? item.aggregated_ranking.filter(e => e.is_current || (this.lowerAndTrim(e.name) === this.lowerAndTrim(this.brandName)))[0].position : -1
        }
        if (this.ordering.indexOf('-') > -1) {
          return list.sort((a, b) => getPos(b) - getPos(a))
        } else {
          return list.sort((a, b) => getPos(a) - getPos(b))
        }
      }
      // SI ORDENAN POR FEELING
      if (this.ordering.indexOf('feeling') > -1) {
        if (this.ordering.indexOf('-') > -1) {
          return list.sort((a, b) => this.getSentimentGlobal(b) - this.getSentimentGlobal(a))
        } else {
          return list.sort((a, b) => this.getSentimentGlobal(a) - this.getSentimentGlobal(b))
        }
      }
      // SI ORDENAN POR TOPICS
      if (this.ordering.indexOf('topics') > -1) {
        if (this.ordering.indexOf('-') > -1) {
          return list.sort((a, b) => b.aggregated_attributes.summary.counts.present - a.aggregated_attributes.summary.counts.present)
        } else {
          return list.sort((a, b) => a.aggregated_attributes.summary.counts.present - b.aggregated_attributes.summary.counts.present)
        }
      }
      // SI ORDENAN POR ALIGNMENT
      if (this.ordering.indexOf('alignment') > -1) {
        if (this.ordering.indexOf('-') > -1) {
          return list.sort((a, b) => b.aggregated_attributes.summary.overall_scores.alignment_score - a.aggregated_attributes.summary.overall_scores.alignment_score)
        } else {
          return list.sort((a, b) => a.aggregated_attributes.summary.overall_scores.alignment_score - b.aggregated_attributes.summary.overall_scores.alignment_score)
        }
      }
      return []
    },
    numberOfPrompts () {
      if (!this.data || !this.sites || this.sites.length === 0 || !Object.keys(this.sites[0]).includes('reputation_index')) return 0
      console.log(this.sites)
      return this.sites[0].reputation_index['openai'].prompts_answers.direct.length + this.sites[0].reputation_index['openai'].prompts_answers.indirect.length
    }
  }
}
</script>
<style lang="scss">
.top-\[60px\]{
top: 60px;
}
.top-\[124px\]{
  top: 124px;
}
.top-\[195px\]{
  top: 195px;
}
#tableLocals{
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #DDDDDD;

  #searchLocal{
    border: 1px solid #c2c2c2;
    border-radius: 8px;
    position: relative;
    img {
      position: absolute;
      top: 10px;
      right: 6px;
    }
    input {
      background-color: #fff;
      padding-right: 30px;
      padding-left: 10px;
      height: 36px;
    }
  }
}
.rowGeo{
    display: grid;
    /* Define las 8 columnas con su mínimo en 'px' y un máximo adaptable '1fr' */
  grid-template-columns: 25fr 7.5fr 7fr 26fr 9fr 12fr 12fr;

    width: 100%; /* El contenedor ocupa todo el ancho disponible */
  padding: 0 15px;
  > div{
    padding: 12px 6px;

  }
  &.head{
    font-size: 12px;
    padding-bottom: 0;
    align-items: end;
    border-bottom: 1px solid #000;
    > div{
      padding: 12px 6px;
      overflow-wrap: break-word;
      word-break: break-all;
    }
  }
  &.body{
    background-color: #fff;
    border-radius: 16px;
    font-size: 13px;
    > div{
      border-right: 1px solid #F2F2F2;
      border-bottom: 1px solid #F2F2F2;
      align-self: stretch;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
    &.open{
      > div{
        justify-content: start;
      }
    }
    .colRestaurant{
      display: flex;
      align-items: start;
      gap: 0.5rem;
      p {
        margin-bottom: 0;
        &.truncated{
          height: 40px;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      button svg{
        min-width: 33px;
      }
    }
    .colVisibility{
      align-items: center;
      img{
        width: 20px;
      }
    }
    .colCompetitors{
      ul{
        list-style: none;
        padding: 0;
      }
    }
    .colSentiment{
      .dimension{
        border: 0;
        padding: 0;
        text-align: left;
        font-size: 12px;
        color: #AFAAAA;
      }
    }
    .colTopics{
      display: flex;
      flex-direction: column;
      gap: 0.3rem;
      .label{
        color: #707070;
        font-size: 12px;
      }
      .number{

      }
      button{
        background-color: #f2f2f2;
        color:#8367DF;
        border-radius: 7px;
        font-size: 11px;
        text-align: center;
        padding: 3px 0;
      }
    }
    .colAlignment{
      border-right: 0;
    }
  }
}
</style>
